import { Modal as MantineModal, ModalProps } from '@mantine/core';
import { FC, memo, PropsWithChildren } from 'react';

import styles from './styles.module.css';

export const Modal: FC<PropsWithChildren<ModalProps>> = memo(
  ({ children, ...props }) => {
    return (
      <MantineModal
        classNames={{
          body: styles.body,
          close: styles.close,
          content: styles.content,
          header: styles.header,
          inner: styles.inner,
          root: styles.root,
          title: styles.title,
        }}
        {...props}
      >
        {children}
      </MantineModal>
    );
  }
);
